import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import { performLogout } from "../../../redux/AuthAction.js";
import { connect, useDispatch, useSelector } from "react-redux";
import { WebUrl, AccessRight } from '../../../util/Constant';
import { checkIfPermissionExist } from "../../../util/PermissionChecker";

const DropdownProfile = props => {
    const { t, i18n } = useTranslation();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const _userData = useSelector(state => state.authState.userData);
    const _dispatch = useDispatch();
    const _history = useHistory();

    /// <summary>
    /// Author : Yong Sheng Chuan
    /// </summary>
    const toggle = () => {
        setDropdownOpen(!dropdownOpen);
    }

    return (
        <>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} className="dropdown navbar-user" tag="li">
                <DropdownToggle tag="a">
                    <span className="d-md-inline">{_userData.username}</span> <b className="caret"></b>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu dropdown-menu-right" tag="ul">
                    <DropdownItem onClick={() => _history.push({ pathname: WebUrl._URL_USER_DETAIL, state: { id: _userData.userId } })}>{t('EDIT_PROFILE')}</DropdownItem>
                    <DropdownItem onClick={() => _history.push({ pathname: WebUrl._URL_USER_CHANGE_PASSWORD })}>{t('CHANGE_PASSWORD')}</DropdownItem>
                    <DropdownItem onClick={() => _dispatch(performLogout())}>{t('LOGOUT')}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </>
    );
}

export default withRouter(DropdownProfile);
